import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'custom-slider',
  templateUrl: './custom-slider.component.html',
  styleUrls: ['./custom-slider.component.scss']
})
export class CustomSliderComponent  {
  @Input('product') product;
  @Output() imageChanged = new EventEmitter<string>();

  images: string[] = [];
  activeIndex: number = 0;
  interval: any;
  isHovered: boolean = false;
  isPaused: boolean = false;

  constructor(private cartService : ShoppingCartService, private dataService : DataService) { }

  ngOnInit() {      
    if (this.product.more_images) {
      this.images = this.product.more_images;
      this.startAutoAdvance();
    }else{
      // let img1 = "https://cdn.shopify.com/s/files/1/0070/7032/files/best-free-stock-photo-websites.jpg?v=1619036042";
      // let img2 = "https://thumbs.dreamstime.com/b/collage-design-picture-young-overjoyed-excited-guy-running-fast-away-against-bullying-finger-point-harassment-isolated-gray-272062512.jpg";
      // this.images = [img1, img2];
    }
  } 

  next(){
   let index = this.activeIndex == this.images.length -1 ? 0 : this.activeIndex+1;
   this.changeImage(index)
   this.restartAutoAdvance();
  }

  prev(){
    let index = this.activeIndex - 1 < 0 ? this.images.length - 1 : this.activeIndex - 1;
    this.changeImage(index);
    this.restartAutoAdvance();
  }

  changeImage(index:number = 0){
    this.activeIndex = index;
    this.imageChanged.emit(this.images[index]);
  }

  navigate(step: number) {
    const newIndex = this.activeIndex + step;

    if (newIndex >= 0 && newIndex < this.images.length) {
      this.changeImage(newIndex);
      this.imageChanged.emit(this.images[newIndex]);
    }else{
      this.changeImage(0);
      this.imageChanged.emit(this.images[0]);
    }
  }

  startAutoAdvance() {
    if (!this.isHovered || !this.isPaused) {
      this.interval = setInterval(() => {
        this.navigate(1);
      }, 3000); // Auto-advance every 3 seconds
    }
  }

  restartAutoAdvance() {
    if(!this.isPaused){
      clearInterval(this.interval);
      this.startAutoAdvance();
    }
  }

  pauseAutoAdvance() {
    this.isPaused = true;
    clearInterval(this.interval);
  }

  resumeAutoAdvance() {
    if (!this.isHovered) {
      this.startAutoAdvance();
    }
  }

  handleMouseEnter() {
    this.isHovered = true;
    this.pauseAutoAdvance();
  }

  handleMouseLeave() {
    this.isHovered = false;
    this.isPaused = true;
    this.resumeAutoAdvance();
  }

  toggleAutoAdvance() {
    if(this.isPaused){
      this.isPaused = false;
      this.restartAutoAdvance();
    }else{
      this.pauseAutoAdvance();
    }
  }
  
}